import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  MediaFormatAdminSchema,
  MediaFormatAdminListResponseSchema,
  CreateMediaFormatSchema,
  UpdateMediaFormatSchema,
  GroupChangeEffectsResponseSchema,
} from '../schemas/media-format-admin.js';

const ListFormatsQuerySchema = z.object({
  search: z.string().optional(),
  groupId: z.number().optional(),
  isActive: z.boolean().optional(),
  page: z.number().optional(),
  pageSize: z.number().max(200).optional(),
});

export const adminMediaFormats = {
  /** GET /admin/media-formats — paginated list (admin only) */
  listFormats: endpoint(
    'GET',
    '/admin/media-formats',
    ListFormatsQuerySchema,
    MediaFormatAdminListResponseSchema,
  ),

  /** GET /admin/media-formats/:id — single format */
  getFormat: endpoint(
    'GET',
    '/admin/media-formats/:id',
    z.object({ id: z.number() }),
    MediaFormatAdminSchema,
  ),

  /** POST /admin/media-formats — create */
  createFormat: endpoint(
    'POST',
    '/admin/media-formats',
    CreateMediaFormatSchema,
    MediaFormatAdminSchema,
  ),

  /** PATCH /admin/media-formats/:id — update */
  updateFormat: endpoint(
    'PATCH',
    '/admin/media-formats/:id',
    z.object({ id: z.number() }).merge(UpdateMediaFormatSchema),
    MediaFormatAdminSchema,
  ),

  /** GET /admin/media-formats/groups — list all active format groups (for filter dropdown) */
  listGroups: endpoint(
    'GET',
    '/admin/media-formats/groups',
    z.object({}),
    z.array(
      z.object({
        id: z.number(),
        code: z.string(),
        name: z.string(),
        sortOrder: z.number(),
        isActive: z.boolean(),
      }),
    ),
  ),

  /** GET /admin/media-formats/:id/group-change-effects?newGroupId=X */
  getGroupChangeEffects: endpoint(
    'GET',
    '/admin/media-formats/:id/group-change-effects',
    z.object({ id: z.number(), newGroupId: z.number() }),
    GroupChangeEffectsResponseSchema,
  ),
};
